import { z } from 'zod';

export const SearchReverseProposalGoodsServiceRequestSchema = z
  .object({
    keyword: z.string().optional(),
    brandId: z.string().optional(),
    page: z.number().min(1),
    size: z.number().min(1).max(100),
  })
  .describe('SearchReverseProposalGoodsServiceRequestSchema');

export type SearchReverseProposalGoodsServiceRequest = z.infer<
  typeof SearchReverseProposalGoodsServiceRequestSchema
>;

const ReverseProposalGoodsItemSchema = z
  .object({
    goodsNo: z.number(),
    imageUrl: z.string(),
    brandName: z.string(),
    goodsName: z.string(),
    salesRate: z.number(),
    price: z.number(),
    isLiked: z.boolean(),
  })
  .describe('ReverseProposalGoodsItemSchema');

export type ReverseProposalGoodsItem = z.infer<typeof ReverseProposalGoodsItemSchema>;

export const SearchReverseProposalGoodsServiceResponseSchema = z.object({
  list: z.array(ReverseProposalGoodsItemSchema),
  total: z.number(),
  pagination: z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
    nextPage: z.number().optional(),
  }),
});

export type SearchReverseProposalGoodsServiceResponse = z.infer<
  typeof SearchReverseProposalGoodsServiceResponseSchema
>;
